import { toEnDigits, toFaDigits } from '~/utils/faDigits'

/** Group digits with commas (e.g. 1000000 → "1,000,000"). */
export function formatGroupedEn(value: number | string | null | undefined): string {
  const n = typeof value === 'number' ? value : Number(toEnDigits(String(value ?? '')).replace(/[^\d.-]/g, ''))
  if (!Number.isFinite(n)) return '0'
  const rounded = Math.trunc(n)
  const sign = rounded < 0 ? '-' : ''
  const abs = String(Math.abs(rounded))
  const grouped = abs.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `${sign}${grouped}`
}

/** Same as `formatGroupedEn` with Persian digits (e.g. ۱,۰۰۰,۰۰۰). */
export function formatGroupedFa(value: number | string | null | undefined): string {
  return toFaDigits(formatGroupedEn(value))
}

/** Format a Rial amount for display: «۱,۰۰۰,۰۰۰ ریال». */
export function formatRialFa(amount: number | string | null | undefined): string {
  return `${formatGroupedFa(amount)} ریال`
}

/**
 * Parse a typed/pasted money string (Persian/Arabic/Western digits, commas, spaces)
 * into an integer. Empty / invalid → `NaN`.
 */
export function parseMoneyInput(raw: string): number {
  const cleaned = toEnDigits(String(raw ?? ''))
    .replace(/[^\d-]/g, '')
  if (!cleaned || cleaned === '-' || cleaned === '--') return Number.NaN
  const n = Number(cleaned)
  return Number.isFinite(n) ? Math.trunc(n) : Number.NaN
}
